  import React, { useRef } from "react";
  // import MarinaFacilityImg from "assets/images/마리나시설지도.png"
  // import MarkerImg from "assets/images/maps-and-flags.png"
  import Com from "components/styledComp/CommStyledComp";
  import FacilitySection from "./FacilitySection";
  import { useSelector } from "react-redux";
import GoDetailUrl from "./GoDetailUrl";


  const MarinaFacility = () => {
    // const [, setSelectedMarker] = useState(null); // add state variable
    // const [hoveredMarkerId, setHoveredMarkerId] = useState(null);

    const markerList = useSelector(state=>{
      return state.MarkerInfo.value;
    });
    const facilityRefs = useRef([])

    // const handleMarkerClick = (marker) => {
    //   setSelectedMarker(marker);

    //   const index = markerList.findIndex(m => m.id === marker.id);
    //   if (index !== -1 && facilityRefs.current[index]) {
    //     const headerHeight = document.querySelector(".header").offsetHeight;
    //     const el = facilityRefs.current[index];
    //     const rect = el.getBoundingClientRect();
    //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //     const targetY = rect.top + scrollTop - headerHeight + 30; 
    //     window.scrollTo({ top: targetY, behavior: "smooth" });
    //   }
    // };

    return (
      <>
        <Com.DivDetailSection border="false">
          <Com.DivDetailHeading m={"0px"}>
            <Com.DetailHeading>마리나 시설</Com.DetailHeading>
          </Com.DivDetailHeading>
        
          {/* <div className="facilityContainer">
            <div className="facilityBox">
              <img className="facilityImg" src={MarinaFacilityImg} alt=""/>
              {
                markerList.map((marker, id) => {

                  const isHovered = marker.id === hoveredMarkerId;

                  return (
                    <div 
                      key={id}
                      style={{
                        position: "absolute",
                        left: `${marker.position.lng}%`,
                        top: `${marker.position.lat}%`,
                        transform: `translate(-50%, -50%) ${isHovered ? "scale(1.2)" : ""}`,
                        zIndex: 2,
                      }}
                      onClick={() => handleMarkerClick(marker)}
                      onMouseOver={() => setHoveredMarkerId(marker.id)}
                      onMouseLeave={() => setHoveredMarkerId(null)}
                    >
                      <img className="facilitymarkerImg" src={MarkerImg} alt=""/>
                    </div>
                  );
                })
              }
              
            </div>
          </div> */}
        </Com.DivDetailSection>
        <div className="marina-facility">
          {markerList.map((marker, id) => (
            <FacilitySection key={id} {...marker} ref={el => facilityRefs.current[id] = el} />
          ))}
        </div>
        <GoDetailUrl url={"https://blog.naver.com/sytai"}/>
      </>
    );
  };

  export default MarinaFacility;
